export default "__VITE_ASSET__HWTKsC$B__"